import { Component, Input } from '@angular/core';
import { BusApiService } from 'src/app/services/api/bus-api.service';

@Component({
  selector: 'app-verification-code-new',
  templateUrl: './verification-code-new.component.html',
  styleUrls: ['./verification-code-new.component.scss'],
})
export class VerificationCodeNewComponent {
  @Input() data: any;
  @Input() platform: any;

  constructor(private api: BusApiService) {}
  code = '';
  loading = false;
  flag = false;

  platformMap: Record<string, string> = {
    'Disney+': 'disney',
    Netflix: 'netflix',
  };

  getCode() {
    const name = this.platformMap[this.platform];

    if (name) {
      this.getAccountCode(name);
    }
  }

  async getAccountCode(name: string) {
    if (this.loading) return;

    this.flag = false;
    this.loading = true;

    try {
      const cdk = this.data.bus.bus_account.initial_verify;

      const r = await this.api.getAccountCode(cdk, name);

      if (r.status === 0) {
        this.code = r.data.code;
      } else {
        this.flag = true;
      }
    } catch (error) {
      this.flag = true;
    } finally {
      this.loading = false;
    }
  }
}
